<template>
  <div class="project-task-pool">
    <div class="first-header">
      <div class="heading-small">Projects task pool</div>
      <filter-by-manager></filter-by-manager>
    </div>
    <div class="second-header">
      <input v-model="search_query" @click="showSearch()" type="text" placeholder="Search clients, projects or tasks">
      <div class="clear-search" @click="clearSearch()" v-show="_searching">
        <i class="fas fa-times"></i>
      </div>
    </div>
    <div class="client-view">
      <client-list v-show="!_searching"></client-list>
      <client-projects v-show="!_searching"></client-projects>
      <project-view v-show="!_searching"></project-view>
      <search-results v-show="_searching"></search-results>
    </div>
  </div>
</template>
<script>
import ClientList from './client-list'
import ClientProjects from './client-projects'
import ProjectView from './project-view'
import SearchResults from './search/search-results'
import FilterByManager from './filter-by-manager'

export default {
  components: {
    ClientList,
    ClientProjects,
    ProjectView,
    SearchResults,
    FilterByManager,
  },
  created() {
    this.$root.$on('SearchResults::toggle', show => {
      this.search_results_shown = show
    })
  },
  data() {
    return {
      search_query: null,
      search_results_shown: true,
    }
  },
  watch: {
    'search_query': function (value) {
      this.search_results_shown = true
      this.$root.$emit('SearchResults::query', value)
    }
  },
  computed: {
    _searching() {
      return this.search_results_shown && this.search_query && this.search_query.length > 2
    }
  },
  methods: {
    clearSearch() {
      this.search_query = null
    },
    showSearch() {
      this.search_results_shown = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/agenda-v2/task-pool/task-pool.vue